import React, { useEffect, useRef, useState } from "react";
import { Images } from "../../../Controller";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Collapse, Tag } from "antd";
import { GetRecentTransactions } from "../../../ApiServices/Apifun";
import { GrTransaction } from "react-icons/gr";
import { HiOutlineArrowDown, HiOutlineArrowUp } from "react-icons/hi2";
import { BiRefresh } from "react-icons/bi";
function DashboardCommon() {
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();
  const [spinState, setSpinState] = useState(false);
  const [recentTransactions, setRecentTransactions] = useState([]);
  const handleGetRecentTransactions = () => {
    setSpinState(true);
    GetRecentTransactions()
      .then((res) => {
        if (res.status) {
          setRecentTransactions(res.transactions);
          setSpinState(false);
        }
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    handleGetRecentTransactions();
  }, []);
  return (
    <div className="m-4">
      {" "}
      <div className="grid grid-cols-2 md:grid-cols-[60%_38%] gap-8">
        {" "}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-[50%_23.4%_23.4%] place-items-start gap-3">
          <div
            className="shadow-[0px_2px_2px_#ccdcff] cursor-pointer p-6 border-gray-300  border bg-white h-36 md:h-44 w-full rounded-xl"
            onClick={() => navigate("/personal-info")}
          >
            <p className="text-rgbaprimary4 text-base md:text-sm lg:text-xl font-bold capitalize">
              Hi , {profiledetail.first_name} {profiledetail.last_name}
            </p>
            <p className="text-rgbaprimary7 text-sm md:text-sm lg:text-lg">
              Ready to earn with HachikinPay
            </p>
          </div>
          {(memberServices.includes("8") ||
            memberServices.includes("25") ||
            memberServices.includes("114")) && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/aepsBankingServiceMain")}
            >
              <img
                src={Images.aeps}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="Aeps"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                AEPS
              </p>
            </div>
          )}
          {(memberServices.includes("103") ||
            memberServices.includes("110") ||
            memberServices.includes("2") ||
            memberServices.includes("116") ||
            memberServices.includes("117") ||
            memberServices.includes("118")) && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/bbpsServiceMain")}
            >
              <img
                src={Images.electricitybill}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                BBPS
              </p>
            </div>
          )}
          {memberServices.includes("105") && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/cmsServiceMain")}
            >
              <img
                src={Images.cashDeposit}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                CMS
              </p>
            </div>
          )}
          {memberServices.includes("111") && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/creditCardServiceMain")}
            >
              <img
                src={Images.credit}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                Credit Card
              </p>
            </div>
          )}
          {/* <div
          className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
          onClick={() => navigate("/dmtServiceMain")}
        >
          <img
            src={Images.cashDeposit}
            className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
            alt="DMT"
          />
          <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
            DMT
          </p>
        </div> */}

          {(memberServices.includes("102") ||
            memberServices.includes("120") ||
            memberServices.includes("9") ||
            memberServices.includes("122")) && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/payment-service")}
            >
              <img
                src={Images.DMT}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                Payment Service
              </p>
            </div>
          )}
          {memberServices.includes("115") && (
            <div
              className="shadow-[0px_2px_2px_#ccdcff] p-2 border-rgbaprimary9 border-b-8 bg-white h-36 md:h-44 w-full rounded-xl cursor-pointer"
              onClick={() => navigate("/recharge2")}
            >
              <img
                src={Images.recharges}
                className="flex justify-start m-auto items-start w-16 text-rgbaprimary6"
                alt="DMT"
              />
              <p className="text-rgbaprimary7 text-base leading-5 font-bold mt-4">
                Recharge
              </p>
            </div>
          )}
        </div>
        <div className="bg-white h-[500px]  overflow-y-scroll rounded-3xl p-3 ">
          <div className="flex justify-start items-center gap-4">
            {/* <p className="bg-primary w-4 h-4 rounded-md"></p> */}
            <GrTransaction className="text-2xl " />
            <p className="font-bold">Recent Transactions</p>
            <BiRefresh
              onClick={handleGetRecentTransactions}
              className={`${spinState ? "animate-spin" : ""}`}
              size={20}
            />
          </div>
          {recentTransactions.length > 0 ? (
            recentTransactions.map((transaction, index) => (
              <Card
                key={index}
                className="mt-2 shadow-[0px_2px_2px_#ccdcff] rounded-xl "
              >
                <div className=" grid sm:grid-cols-1 md:grid-cols-[10%_60%_30%] sm:gap-2 md:gap-0 items-center">
                  <div>
                    {transaction.amount_type === "Cr" ? (
                      <HiOutlineArrowDown className="text-xl text-green-500" />
                    ) : (
                      <HiOutlineArrowUp className="text-xl text-red-500" />
                    )}{" "}
                  </div>
                  <div>
                    {" "}
                    <p className="text-black text-sm font-medium">
                      {transaction.service_name}
                    </p>
                    <p className="text-gray-500 text-xs">
                      {transaction.transaction_id}
                    </p>
                    <p className="text-gray-500 text-xs mt-2 font-medium">
                      {transaction.transaction_date}
                    </p>
                  </div>
                  <div>
                    {" "}
                    <p className="text-black text-sm font-medium">
                      {transaction.amount_type === "Cr" ? "+" : "-"}{" "}
                      {transaction.amount}
                    </p>
                    <p className="text-black text-xs">
                      {transaction.status === "0" ? (
                        <Tag color="warning">Pending</Tag>
                      ) : transaction.status === "1" ? (
                        <Tag color="success">Success</Tag>
                      ) : (
                        <Tag color="error">Failed</Tag>
                      )}
                    </p>
                  </div>
                </div>
              </Card>
            ))
          ) : (
            <p className="text-rgbaprimary7 text-sm">No recent transactions</p>
          )}
          {/* <Collapse
            onChange={(val) => setCollapsed(val)}
            defaultActiveKey={["0"]}
            ghost
            items={accordionData}
          /> */}
        </div>
      </div>
    </div>
  );
}
export default DashboardCommon;
